import React from "react";
import PropType from "prop-types";
import { Empty, Row, Col } from "antd";
import {
  Chart,
  Geom,
  Axis,
  Tooltip,
  Legend,
  Coord,
  useTheme,
  registerTheme,
  getTheme,
} from "bizcharts";
import { ScreenSize } from "utils/constants";

registerTheme("my-theme", {
  defaultColor: "#2dbecd",
  geometries: {
    interval: {
      rect: {
        default: { style: { fill: "#2dbecd", fillOpacity: 0.95 } },
        active: { style: { stroke: "#5AD8A6", lineWidth: 1 } },
        inactive: { style: { fillOpacity: 0.3, strokeOpacity: 0.3 } },
        selected: {},
      },
    },
  },
});

const HistoricalChart = (props) => {
  const data = [
    { week: "Week 1", total_sales: 275 },
    { week: "Week 2", total_sales: 115 },
    { week: "Week 3", total_sales: 120 },
    { week: "Week 4", total_sales: 350 },
    { week: "Week 5", total_sales: 150 },
    { week: "Week 6", total_sales: 210 },
    { week: "Week 7", total_sales: 240 },
    { week: "Week 8", total_sales: 300 },
  ];

  const [theme, setTheme] = useTheme("my-theme");

  const cols = {
    total_sales: { alias: "Total Sales" },
    week: { alias: "Week" },
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div>
      <h1 style={{ textAlign: "center", fontWeight: "bold", fontSize: 18 }}>
        Historical Weekly Order Trend in MYR
      </h1>

      <Chart
        autoFit
        height={400}
        data={props.data}
        padding={[40, 20, 80, 60]}
        scale={cols}
        theme={theme}
      >
        <Axis name="week" title />
        <Axis
          name="total_sales"
          label={{
            formatter: (val) => numberWithCommas(val),
          }}
        />
        <Legend visible={false} />
        {/* <Legend position="top" dy={-20} /> */}
        <Tooltip>
          {(title, items) => {
            return (
              <div style={{ padding: 10 }}>
                {items.map((value, index) => {
                  // console.log(value);
                  return (
                    <div key={index + 1}>
                      <Row align="middle">
                        <Col
                          style={{
                            backgroundColor: items[0].color,
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            marginRight: 12,
                          }}
                        />
                        <Col>
                          <span style={{ marginRight: 24 }}>{title} :</span>
                          {"RM\xa0"}
                          {numberWithCommas(value.data.total_sales)}
                        </Col>
                      </Row>
                    </div>
                  );
                })}
              </div>
            );
          }}
        </Tooltip>
        <Geom
          type="interval"
          position="week*total_sales"
          label={[
            "total_sales",
            (val) => {
              var res = "RM\xa0" + numberWithCommas(val);

              if (window.innerWidth > ScreenSize.xs) {
                return {
                  content: res,
                  style: {
                    fill: "#722ed1",
                    fontSize: 12,
                  },
                };
              } else {
                return null;
              }
            },
          ]}
          // theme={useTheme('my-theme')}
          /* color="genre" */
        />
      </Chart>
    </div>
  );
};

HistoricalChart.propType = {
  style: PropType.object,
};

export default HistoricalChart;
